export default __webpack_public_path__ + "static/media/category-6.665cb79d.svg";